// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { getCurrentLanguage } from 'owa-localize';
import { getQueryStringParameter, hasQueryStringParameter } from 'owa-querystring';
import { isGulping } from 'owa-config/lib/bootstrapOptions';
import { type OwaWorkload } from 'owa-workloads';

const MANIFEST_SLUGS: Partial<Record<OwaWorkload, string>> = {
    [1]: 'mini-manifest.json',
    [1024]: 'mini-calendar.json',
    [2048]: 'mini-people.json',
};

export function initializeManifest(workload: OwaWorkload) {
    updateManifestLink(getCurrentLanguage(), workload);
}

function updateManifestLink(culture: string, workload: OwaWorkload) {
    if (!isGulping()) {
        let newManifestUrl = `/mail/${MANIFEST_SLUGS[workload]}?culture=${culture}`;
        if (hasQueryStringParameter('branch')) {
            newManifestUrl += `&branch=${getQueryStringParameter('branch')}`;
        }
        updateOrAddManifestLink(newManifestUrl);
    }
}

function updateOrAddManifestLink(newManifestUrl: string) {
    const elem = document.head.querySelector("link[rel='manifest']") as HTMLLinkElement;
    if (elem) {
        elem.href = newManifestUrl;
    } else {
        const newLinkElement = document.createElement('link');
        newLinkElement.rel = 'manifest';
        newLinkElement.href = newManifestUrl;
        document.head.appendChild(newLinkElement);
    }
}
